import clsx from 'clsx'
import React, {
  type ElementType,
  type FC,
  type ReactNode,
  useCallback,
} from 'react'

export type CardAdvantageProps = {
  advantage: {
    Icon: ElementType
    content: ReactNode
    modalTrigger?: (open: () => void) => ReactNode
    modalTitle?: string
    modalContent?: ReactNode
    disabled?: boolean
  }
  openModal: (title: string, content: ReactNode) => void
}

const CardAdvantage: FC<CardAdvantageProps> = ({ advantage, openModal }) => {
  const {
    Icon,
    content,
    modalTitle,
    modalContent,
    modalTrigger,
    disabled = false,
  } = advantage

  const open = useCallback(() => {
    openModal(modalTitle, modalContent)
  }, [modalTitle, modalContent])

  return (
    <div
      className={clsx(
        'py-8',
        'px-4',
        'tablet:px-5',
        'laptop:px-10',
        disabled ? 'opacity-20' : 'opacity-100'
      )}
    >
      <Icon className="inline-block h-[1em] w-[1em] shrink-0 select-none fill-slate-400 text-150 text-slate-400" />
      {content}
      {Boolean(modalTrigger) && modalTrigger(open)}
    </div>
  )
}

export default CardAdvantage
